import { render, staticRenderFns } from "./categoryProductslist.vue?vue&type=template&id=4ab647fa&"
import script from "./categoryProductslist.vue?vue&type=script&lang=js&"
export * from "./categoryProductslist.vue?vue&type=script&lang=js&"
import style0 from "./categoryProductslist.vue?vue&type=style&index=0&id=4ab647fa&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab647fa')) {
      api.createRecord('4ab647fa', component.options)
    } else {
      api.reload('4ab647fa', component.options)
    }
    module.hot.accept("./categoryProductslist.vue?vue&type=template&id=4ab647fa&", function () {
      api.rerender('4ab647fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/categoryProductslist.vue"
export default component.exports